import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { QualityControlSetProjectLinkContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-set-project-link-container.model";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class QualityControlSetProjectLinkService extends BaseApiTemplateService<QualityControlSetProjectLinkContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/set-project-links";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/set-project-links";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/set-project-links";
		this.httpClient = http;
	}
}
